import ArrowRightFilled from "./SVG/arrow-thick-right-2.svg?react";

const ArrowRightFilledIcon = ({ title }: { title?: string }) => {
  return <ArrowRightFilled title={title} />;
};

export default ArrowRightFilledIcon;
